export const unitType = {
  imperial: "imperial",
  metric: "metric",
};
